module.exports = __webpack_public_path__ + "static/logo-web-c86923c5067f9b832593f934bbdcd95b.png";